<template src="./login.html" />
<style scoped src="./login.css" />

<script>
const requestHelper = require('../../helpers/requestHelper.js');
import popupWindow from '../../components/popupWindow/popupWindow.vue';

export default {
  data() {
    return {
      username: "",
      password: "",
    };
  },
  components: {
    popupWindow
  },
  mounted() {
    var loginData = localStorage.getItem('login');
    if (loginData) {
      this.$router.push('/dashboard');
    }
  },
  methods: {
    async login() {
      try {
        let encCred = btoa(`${this.username}:${this.password}`);
        let auth = `Basic ${encCred}`;
        let loginResp = await requestHelper.loginRequest('/verifyUser', 'post', auth);
        const statusCode = loginResp?.data?.statusCode;
        if (statusCode === 200) {
          const loginData = loginResp?.data?.data;
          localStorage.setItem('userId', loginData.id);
          localStorage.setItem('token', loginData.sessionToken);
          localStorage.setItem('login', auth);

          let roleId = await requestHelper.request(`/getUserRoleId`, null, 'get');
          roleId = roleId.data.data.userRoleId;

          const userPermissions = await requestHelper.request(`/getUserRolePermission/${roleId}`, null, 'get');
          const permissions = userPermissions.data.data;
          console.log('userPermissions - login', userPermissions);
          const permissionsObj = {};

          for (const module in permissions) {
            const { moduleName, permissionList } = permissions[module];
            permissionList.forEach(permission => {
              const lowerCasePermissionName = permission.name.toLowerCase();
              if (!permissionsObj[lowerCasePermissionName]) {
                permissionsObj[lowerCasePermissionName] = [];
              }
              if (!permissionsObj[lowerCasePermissionName].includes(moduleName)) {
                permissionsObj[lowerCasePermissionName].push(moduleName);
              }
            });
          }
          console.log('permissionsObj', permissionsObj);
          let permissionsArray = [];

          for (const [action, entities] of Object.entries(permissionsObj)) {
            console.log(action, entities);
            entities.forEach(entity => {
              permissionsArray.push(`${action}${entity}`);
            });
          }
          console.log('permissionsArray', permissionsArray);

          this.$store.commit('setPermissions', permissionsArray);
          this.$router.push('/dashboard');
        }
        else {
          this.$refs.popupComponent.openPopup("Invalid Credentials");
        }
      } catch (error) {
        this.$refs.popupComponent.openPopup("Invalid Credentials");
      }
    }
  }
};
</script>
